import React, { Component } from 'react';
import KeyboardKey from './KeyboardKey';
import _ from 'lodash';
import Shared from '../../utils/shared.js'

class UserInput extends Component {

  constructor(props) {
    super(props);
    this.state = {
      text: "",
      module: this.props.module,
      virtual_keyboard_mode: 0
    }
    this.handleKeyPress = this.handleKeyPress.bind(this);
    this.deleteText = this.deleteText.bind(this);
    this.normalMode = this.normalMode.bind(this);
    this.capitalMode = this.capitalMode.bind(this);
    this.submitText = this.submitText.bind(this);
  }

  shouldComponentUpdate(prevProps, prevState) {
      if (Shared.shallowEqual(this.state, prevState)) {
          return false;
      }
      return true;
  }

  handleKeyPress(val) {
    if (typeof val === "function") {
      val();
    }
    else {
      let str = this.state.text + val;
      if (str.length < 40) {
        this.setState({
          text: str
        })
      }
    }

  }

  normalMode() {
    this.setState({
        virtual_keyboard_mode: 0
    })
  }

  capitalMode() {
    this.setState({
        virtual_keyboard_mode: 1
    })
  }

  deleteText() {
    if (this.state.text.length > 0) {
      let str = this.state.text.substring(0, this.state.text.length - 1);
      this.setState({
        text: str
      })
    }
  }

  submitText() {
    //this.props.submitUserInput({ text: this.state.text }); TODO: need to setup slim app to handle this
    this.props.navroute(null, "Input Confirmation", "Input Submit", null)
    //this.props.history.push('/input_confirmation');
  }

  render() {

    let headerStyle = {
      color: 'white',
      fontSize: this.props.screen.r16_9.p10 * 0.35,
      lineHeight: String(this.props.screen.r16_9.p10 * 0.6 * 0.78) + "px",
    }

    let textStyle = {
      color: 'white',
      fontSize: this.props.screen.r16_9.p10 * 0.35,
    }

    let keystd = {
      width: this.props.screen.r16_9.p10 * 0.8,
      height: this.props.screen.r16_9.p10 * 0.8,
      margin: this.props.screen.r16_9.p10 * 0.04,
      display: 'inline-block',
      backgroundColor: 'white',
      textAlign: 'center',
    }

    // let keyhide = {
    //   width: this.props.displayData.sizes.s4,
    //   height: this.props.displayData.sizes.s4,
    //   margin: this.props.displayData.sizes.marginTiny,
    //   display: 'inline-block',
    //   backgroundColor: 'white',
    //   textAlign: 'center',
    // }    

    let keyspace = {
      width: this.props.screen.r16_9.p10 * 1.6,
      height: this.props.screen.r16_9.p10 * 0.8,
      margin: this.props.screen.r16_9.p10 * 0.04,
      display: 'inline-block',
      backgroundColor: 'white',
      textAlign: 'center',
    }

    let keycom = {
      width: this.props.screen.r16_9.p10 * 1.6,
      height: this.props.screen.r16_9.p10 * 0.8,
      margin: this.props.screen.r16_9.p10 * 0.04,
      display: 'inline-block',
      backgroundColor: 'white',
      textAlign: 'center',
    }

    //move just the keyboard input mode into redux, so that this state doesn't need to be passed from parent to child, or alternatively use a parent->child or child->parent watch.

    return (
      <div style={{ position: 'fixed', left: this.props.screen.r16_9.left, width: this.props.screen.r16_9.width, height: '100vh', fontSize: this.props.screen.r16_9.p10 * 0.35, color: 'black' }}>
        <div className="helem velem" style={{ position: 'relative' }}>

          <span style={headerStyle}>{this.state.module.contents.header}</span><br /><br />
          <span style={textStyle}>{this.state.module.contents.text}</span><br /><br />
          <div style={{ display: 'inline-block', width: '30vw', height: this.props.screen.r16_9.p10 * 1, backgroundColor: "#c5dae7" }}>
            <span style={{ height: this.props.screen.r16_9.p10 * 1, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>&nbsp;{this.state.text}&nbsp;</span>
          </div>
          <br /><br />
          <KeyboardKey keyval={[1, 1, null]} virtual_keyboard_mode={this.state.virtual_keyboard_mode} handleKeyPress={this.handleKeyPress} mainstyle={keystd} contents={[1, 1, null]} />
          <KeyboardKey keyval={[2, 2, null]} virtual_keyboard_mode={this.state.virtual_keyboard_mode} handleKeyPress={this.handleKeyPress} mainstyle={keystd} contents={[2, 2, null]} />
          <KeyboardKey keyval={[3, 3, null]} virtual_keyboard_mode={this.state.virtual_keyboard_mode} handleKeyPress={this.handleKeyPress} mainstyle={keystd} contents={[3, 3, null]} />
          <KeyboardKey keyval={[4, 4, null]} virtual_keyboard_mode={this.state.virtual_keyboard_mode} handleKeyPress={this.handleKeyPress} mainstyle={keystd} contents={[4, 4, null]} />
          <KeyboardKey keyval={[5, 5, null]} virtual_keyboard_mode={this.state.virtual_keyboard_mode} handleKeyPress={this.handleKeyPress} mainstyle={keystd} contents={[5, 5, null]} />
          <KeyboardKey keyval={[6, 6, null]} virtual_keyboard_mode={this.state.virtual_keyboard_mode} handleKeyPress={this.handleKeyPress} mainstyle={keystd} contents={[6, 6, null]} />
          <KeyboardKey keyval={[7, 7, null]} virtual_keyboard_mode={this.state.virtual_keyboard_mode} handleKeyPress={this.handleKeyPress} mainstyle={keystd} contents={[7, 7, null]} />
          <KeyboardKey keyval={[8, 8, null]} virtual_keyboard_mode={this.state.virtual_keyboard_mode} handleKeyPress={this.handleKeyPress} mainstyle={keystd} contents={[8, 8, null]} />
          <KeyboardKey keyval={[9, 9, null]} virtual_keyboard_mode={this.state.virtual_keyboard_mode} handleKeyPress={this.handleKeyPress} mainstyle={keystd} contents={[9, 9, null]} />
          <KeyboardKey keyval={[0, 0, null]} virtual_keyboard_mode={this.state.virtual_keyboard_mode} handleKeyPress={this.handleKeyPress} mainstyle={keystd} contents={[0, 0, null]} />
          <KeyboardKey keyval={[this.deleteText, this.deleteText, this.deleteText]} virtual_keyboard_mode={this.state.virtual_keyboard_mode} handleKeyPress={this.handleKeyPress} mainstyle={keystd} contents={['DELETE', 'DELETE', 'DELETE']} />
          <br />

          <KeyboardKey keyval={['q', 'Q', null]} virtual_keyboard_mode={this.state.virtual_keyboard_mode} handleKeyPress={this.handleKeyPress} mainstyle={keystd} contents={['q', 'Q', null]} />
          <KeyboardKey keyval={['w', 'W', null]} virtual_keyboard_mode={this.state.virtual_keyboard_mode} handleKeyPress={this.handleKeyPress} mainstyle={keystd} contents={['w', 'W', null]} />
          <KeyboardKey keyval={['e', 'E', null]} virtual_keyboard_mode={this.state.virtual_keyboard_mode} handleKeyPress={this.handleKeyPress} mainstyle={keystd} contents={['e', 'E', null]} />
          <KeyboardKey keyval={['r', 'R', null]} virtual_keyboard_mode={this.state.virtual_keyboard_mode} handleKeyPress={this.handleKeyPress} mainstyle={keystd} contents={['r', 'R', null]} />
          <KeyboardKey keyval={['t', 'T', null]} virtual_keyboard_mode={this.state.virtual_keyboard_mode} handleKeyPress={this.handleKeyPress} mainstyle={keystd} contents={['t', 'T', null]} />
          <KeyboardKey keyval={['y', 'Y', null]} virtual_keyboard_mode={this.state.virtual_keyboard_mode} handleKeyPress={this.handleKeyPress} mainstyle={keystd} contents={['y', 'Y', null]} />
          <KeyboardKey keyval={['u', 'U', null]} virtual_keyboard_mode={this.state.virtual_keyboard_mode} handleKeyPress={this.handleKeyPress} mainstyle={keystd} contents={['u', 'U', null]} />
          <KeyboardKey keyval={['i', 'I', null]} virtual_keyboard_mode={this.state.virtual_keyboard_mode} handleKeyPress={this.handleKeyPress} mainstyle={keystd} contents={['i', 'I', null]} />
          <KeyboardKey keyval={['o', 'O', null]} virtual_keyboard_mode={this.state.virtual_keyboard_mode} handleKeyPress={this.handleKeyPress} mainstyle={keystd} contents={['o', 'O', null]} />
          <KeyboardKey keyval={['p', 'P', null]} virtual_keyboard_mode={this.state.virtual_keyboard_mode} handleKeyPress={this.handleKeyPress} mainstyle={keystd} contents={['p', 'P', null]} />
          <KeyboardKey keyval={['@', null, null]} virtual_keyboard_mode={this.state.virtual_keyboard_mode} handleKeyPress={this.handleKeyPress} mainstyle={keystd} contents={['@', '@', null]} />
          <br />

          <KeyboardKey keyval={['a', 'A', null]} virtual_keyboard_mode={this.state.virtual_keyboard_mode} handleKeyPress={this.handleKeyPress} mainstyle={keystd} contents={['a', 'A', null]} />
          <KeyboardKey keyval={['s', 'S', null]} virtual_keyboard_mode={this.state.virtual_keyboard_mode} handleKeyPress={this.handleKeyPress} mainstyle={keystd} contents={['s', 'S', null]} />
          <KeyboardKey keyval={['d', 'D', null]} virtual_keyboard_mode={this.state.virtual_keyboard_mode} handleKeyPress={this.handleKeyPress} mainstyle={keystd} contents={['d', 'D', null]} />
          <KeyboardKey keyval={['f', 'F', null]} virtual_keyboard_mode={this.state.virtual_keyboard_mode} handleKeyPress={this.handleKeyPress} mainstyle={keystd} contents={['f', 'F', null]} />
          <KeyboardKey keyval={['g', 'G', null]} virtual_keyboard_mode={this.state.virtual_keyboard_mode} handleKeyPress={this.handleKeyPress} mainstyle={keystd} contents={['g', 'G', null]} />
          <KeyboardKey keyval={['h', 'H', null]} virtual_keyboard_mode={this.state.virtual_keyboard_mode} handleKeyPress={this.handleKeyPress} mainstyle={keystd} contents={['h', 'H', null]} />
          <KeyboardKey keyval={['j', 'J', null]} virtual_keyboard_mode={this.state.virtual_keyboard_mode} handleKeyPress={this.handleKeyPress} mainstyle={keystd} contents={['j', 'J', null]} />
          <KeyboardKey keyval={['k', 'K', null]} virtual_keyboard_mode={this.state.virtual_keyboard_mode} handleKeyPress={this.handleKeyPress} mainstyle={keystd} contents={['k', 'K', null]} />
          <KeyboardKey keyval={['l', 'L', null]} virtual_keyboard_mode={this.state.virtual_keyboard_mode} handleKeyPress={this.handleKeyPress} mainstyle={keystd} contents={['l', 'L', null]} />
          <KeyboardKey keyval={['_', '_', null]} virtual_keyboard_mode={this.state.virtual_keyboard_mode} handleKeyPress={this.handleKeyPress} mainstyle={keystd} contents={['_', '_', null]} />
          <KeyboardKey keyval={['&', '&', null]} virtual_keyboard_mode={this.state.virtual_keyboard_mode} handleKeyPress={this.handleKeyPress} mainstyle={keystd} contents={['&', '&', null]} />
          <br />

          <KeyboardKey keyval={['z', 'Z', null]} virtual_keyboard_mode={this.state.virtual_keyboard_mode} handleKeyPress={this.handleKeyPress} mainstyle={keystd} contents={['z', 'Z', null]} />
          <KeyboardKey keyval={['x', 'X', null]} virtual_keyboard_mode={this.state.virtual_keyboard_mode} handleKeyPress={this.handleKeyPress} mainstyle={keystd} contents={['x', 'X', null]} />
          <KeyboardKey keyval={['c', 'C', null]} virtual_keyboard_mode={this.state.virtual_keyboard_mode} handleKeyPress={this.handleKeyPress} mainstyle={keystd} contents={['c', 'C', null]} />
          <KeyboardKey keyval={['v', 'V', null]} virtual_keyboard_mode={this.state.virtual_keyboard_mode} handleKeyPress={this.handleKeyPress} mainstyle={keystd} contents={['v', 'V', null]} />
          <KeyboardKey keyval={['b', 'B', null]} virtual_keyboard_mode={this.state.virtual_keyboard_mode} handleKeyPress={this.handleKeyPress} mainstyle={keystd} contents={['b', 'B', null]} />
          <KeyboardKey keyval={['n', 'N', null]} virtual_keyboard_mode={this.state.virtual_keyboard_mode} handleKeyPress={this.handleKeyPress} mainstyle={keystd} contents={['n', 'N', null]} />
          <KeyboardKey keyval={['m', 'M', null]} virtual_keyboard_mode={this.state.virtual_keyboard_mode} handleKeyPress={this.handleKeyPress} mainstyle={keystd} contents={['m', 'M', null]} />
          <KeyboardKey keyval={['.', '.', null]} virtual_keyboard_mode={this.state.virtual_keyboard_mode} handleKeyPress={this.handleKeyPress} mainstyle={keystd} contents={['.', '.', null]} />
          <KeyboardKey keyval={['-', '-', null]} virtual_keyboard_mode={this.state.virtual_keyboard_mode} handleKeyPress={this.handleKeyPress} mainstyle={keystd} contents={['-', '-', null]} />
          <KeyboardKey keyval={['*', '*', null]} virtual_keyboard_mode={this.state.virtual_keyboard_mode} handleKeyPress={this.handleKeyPress} mainstyle={keystd} contents={['*', '*', null]} />
          <KeyboardKey keyval={['?', '?', null]} virtual_keyboard_mode={this.state.virtual_keyboard_mode} handleKeyPress={this.handleKeyPress} mainstyle={keystd} contents={['?', '?', null]} />

          <br />
          <div style={keystd}><span className="kspn">=/#</span></div>
          <KeyboardKey keyval={[this.capitalMode, this.normalMode, null]} virtual_keyboard_mode={this.state.virtual_keyboard_mode} handleKeyPress={this.handleKeyPress} mainstyle={keystd} contents={['UPCASE', 'DOWNCASE', null]} />
          <KeyboardKey keyval={[' ', ' ', ' ']} virtual_keyboard_mode={this.state.virtual_keyboard_mode} handleKeyPress={this.handleKeyPress} mainstyle={keyspace} contents={['SPACE', 'SPACE', 'SPACE']} />
          <KeyboardKey keyval={['.com', '.com', '.com']} virtual_keyboard_mode={this.state.virtual_keyboard_mode} handleKeyPress={this.handleKeyPress} mainstyle={keycom} contents={['.com', '.com', '.com']} />
          <KeyboardKey keyval={['Submit', 'Submit', 'Submit']} virtual_keyboard_mode={this.state.virtual_keyboard_mode} handleKeyPress={this.submitText} mainstyle={keycom} contents={['Submit', 'Submit', 'Submit']} />


        </div>
      </div>

    )
  }
}

export default UserInput;


// WEBPACK FOOTER //
// ./src/Components/UserInput/UserInput.js